import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  IApprobationFormData,
  IContractDetalhes,
  IContractFinanciamento,
  IContractInput,
  IContractInputsForm,
  IControlsFromResolver
} from 'src/app/models/contract';
import { DialogTypeEnum, IDialogConfirm } from 'src/app/models/dialog';
import { HeaderTitle, IGenericContract } from 'src/app/models/generic';
import { ITab } from 'src/app/models/tabs';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { ApiContractService } from 'src/app/services/api/api-contract.service';
import { ApiVerificationService } from 'src/app/services/api/api-verification.service';
import { DataService } from 'src/app/services/data.service';
import { AprovacaoModalFormComponent } from './aprovacao-modal-form/aprovacao-modal-form.component';

@Component({
  selector: 'app-aprovacao',
  templateUrl: './aprovacao.component.html',
  styleUrls: ['./aprovacao.component.scss']
})
export class AprovacaoComponent implements OnInit {
  form!: FormGroup;
  formGeneric!: FormGroup;

  contractDetalhes: IContractInput[] = [];
  contractFinanciamento: IContractInput[] = [];

  tabs: ITab[] = [];
  currentTab = 1;

  inputControlsFromResolver!: IControlsFromResolver;

  currentContractId: string = '';
  approveContractId: string = '';
  contractCurrentVersionData!: IGenericContract;
  currentVersion = false;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _dataService: DataService,
    private _dialog: MatDialog,
    private _confirmDialogService: ApiDialogService,
    private _verificationService: ApiVerificationService,
    private _contractService: ApiContractService,
    private _router: Router
  ) {
    this.getAndSetHeaderTitle();
  }

  ngOnInit(): void {
    this.currentContractId = this._contractService.contractData.ContractId;
    this.formGeneric = this._contractService.form;
    this.generateTabs();
    this.getDataFromResolver();
  }

  generateTabs(): void {
    this.tabs = [
      { title: 'Nova versão', id: 1 },
      { title: 'Antiga versão', id: 2 }
    ];
  }

  buildForm(): void {
    this.form = new FormGroup({
      Number: new FormControl(null),
      QueryNumber: new FormControl(null),
      Amount: new FormControl(null),
      Product: new FormControl(null),
      valorVenda: new FormControl(null),
      OperationType: new FormControl(null),
      Status: new FormControl(null),
    });

    const { detalhes, financiamento } = this.inputControlsFromResolver;

    const inputs = [...detalhes, ...financiamento];

    const inputsFromArrayToObj: {
      [key: string]: string | number | null | undefined;
    } = {};

    inputs.forEach((el) => {
      inputsFromArrayToObj[el.controlName] = el.value;
    });

    this.getContractByVersion();
  }

  changeTab(tab: number): void {
    this.currentTab = tab + 1;

    this.currentVersion = this.currentTab === 1 ? false : true;

    this.getContractByVersion();
  }

  getContractByVersion(): void {
    this._verificationService
      .getContractById(this.currentContractId, this.currentVersion)
      .subscribe((res) => {
        this.contractCurrentVersionData = res.Data;
        if (!this.currentVersion)
          this.approveContractId = this.contractCurrentVersionData.ContractId;
          
        this.form.patchValue(this.contractCurrentVersionData);
        this._contractService.patchForm(this.contractCurrentVersionData);
      });
  }

  getAndSetHeaderTitle(): void {
    const title = this._activatedRoute.snapshot.routeConfig
      ?.title as HeaderTitle;
    this._dataService.setHeaderTitle(title);
  }

  getDataFromResolver(): void {
    this._activatedRoute.data.subscribe({
      next: (data) => {
        this.inputControlsFromResolver = data['contracts'];
        this.buildForm();
      }
    });
  }

  handleOpenModal(): void {
    const data: IApprobationFormData = {
      inputs: this.inputControlsFromResolver,
      form: this._contractService.form,
      id: this.currentContractId,
      currentTab: this.currentTab,
      currentVersion: this.currentVersion
    };

    this._dialog.open(AprovacaoModalFormComponent, {
      disableClose: true,
      data,
      panelClass: 'generic-dialog',
      ariaLabel: 'Detalhes da aprovação'
    });
  }

  approveDisapproveChanges(approbation: string): void {
    if (approbation === 'reject-changes') {
      const dialogData: IDialogConfirm = {
        type: DialogTypeEnum.OptionalWithField,
        appearance: 'modern',
        template: {
          boldTitle: 'Reprovar edição',
          title: 'Tem certeza que deseja reprovar a edição? Se sim, coloque uma justificativa.',
          confirm: 'Sim',
          dismiss: 'Não',
          description: 'Observações'
        }
      };

      this._confirmDialogService.openDialog(dialogData).then((res) => {
        if (res) {
          this._contractService
            .approveDisapproveChanges(this.approveContractId, approbation, String(res))
            .subscribe((res) => {
              if (res) {
                this._router.navigate(['/esteira-apuracao']);
              }
            });
        }
      });
    } else {
      this._contractService
        .approveDisapproveChanges(this.approveContractId, approbation)
        .subscribe((res) => {
          if (res) {
            const dialogData: IDialogConfirm = {
              type: DialogTypeEnum.Confirmation,
              appearance: 'modern',
              template: {
                boldTitle: 'Sucesso',
                title: 'Proposta aprovada com sucesso!',
                confirm: 'Ok'
              }
            };

            this._confirmDialogService
              .openDialog(dialogData)
              .then(() => this._router.navigate(['/esteira-apuracao']));
          }
        });
    }
  }
}
